export const config = {
	api_url: "https://react-beer4you.herokuapp.com",
	pict_url: "https://react-beer4you.herokuapp.com/images/"
}